import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Slack = (props: TIconProps): ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      id="slack_layer"
      fill="hsl(from hsl(299 55% 19%) h s 42%)"
      d="M5.06,15.11a2.52,2.52,0,1,1-2.52-2.49H5.06Zm1.26,0a2.52,2.52,0,0,1,5,0v6.24a2.52,2.52,0,0,1-5,0Z"
    />
    <path
      id="slack_layer_2"
      data-name="layer"
      fill="hsl(from hsl(299 55% 19%) h s 66%)"
      d="M8.84,5.1a2.5,2.5,0,1,1,2.52-2.5V5.1Zm0,1.26a2.5,2.5,0,1,1,0,5H2.52a2.5,2.5,0,1,1,0-5Z"
    />
    <path
      id="slack_layer_3"
      data-name="layer"
      fill="hsl(from hsl(299 55% 19%) h s 58%)"
      d="M18.94,8.86a2.52,2.52,0,1,1,2.52,2.49H18.94Zm-1.26,0a2.52,2.52,0,0,1-5,0V2.6a2.52,2.52,0,0,1,5,0Z"
    />
    <path
      id="slack_layer_1"
      data-name="layer 1"
      fill="hsl(from hsl(299 55% 19%) h s 74%)"
      d="M15.16,18.86a2.5,2.5,0,1,1-2.52,2.49V18.86Zm0-1.25a2.5,2.5,0,1,1,0-5h6.32a2.5,2.5,0,1,1,0,5Z"
    />
  </svg>
);
